import { render, staticRenderFns } from "./ProspectStatusBadge.vue?vue&type=template&id=15ff5ab0"
import script from "./ProspectStatusBadge.vue?vue&type=script&lang=js"
export * from "./ProspectStatusBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports